import React from "react";

const WhyChooseUsCard = ({data}) => {
    // console.log("s", data);
    return (
        <>
            <div >
                <div className="why-choose-item">
                    <div className="why-choose-icon">
                        <img src={data.contents.icon_file} alt={data.title} />
                    </div>
                    <div className="media-body">
                        <h2>{data.contents.title}</h2>
                        <p>{data.contents.description}</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WhyChooseUsCard;